import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { collegeGuideContent } from '../content';

const whyMattersDetail = [
  collegeGuideContent.intro.whyMatters.title,
  ...collegeGuideContent.intro.whyMatters.points,
].join('\n');

const faqDetail = collegeGuideContent.faq
  .map((faq) => `${faq.question}\n${faq.answer}`)
  .join('\n\n');

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Explore College Types',
    description:
      'Grid of clickable college type cards. Each card opens a detail modal with key points, considerations, and questions to ask.',
    detail: whyMattersDetail,
  });

  useRegisterAgentContext({
    kind: 'list',
    description: 'College types available to explore.',
    data: collegeGuideContent.collegeProfiles,
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'Frequently Asked Questions',
    description: 'Common questions about colleges within universities.',
    detail: faqDetail,
  });
};
